import { toISODateOnly } from '../../../../../../../utils/dateUtils';
import { SalaryStatus } from './types';

const getToday = (): string => toISODateOnly(new Date());

export const isActiveOrFutureSalary = (endDate: string | null): boolean => {
  if (!endDate) return true;
  return endDate >= getToday();
};

export const isActiveSalary = (
  startDate: string | null,
  endDate: string | null,
): boolean => {
  const today = getToday();
  const started = !startDate || startDate <= today;
  const notEnded = !endDate || endDate >= today;
  return started && notEnded;
};

export const getStatusBadgeVariant = (status: string) => {
  switch (status) {
    case SalaryStatus.ACTIVE:
      return 'success';
    case SalaryStatus.UPCOMING:
      return 'warning';
    case SalaryStatus.EXPIRED:
      return 'secondary';
    default:
      return 'secondary';
  }
};
